import React, { useState, useEffect } from 'react'
import FetchApi from '../../customhooks/functionFetchApi'
import DataTable from 'react-data-table-component';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const ViewRecalldetail = ({ jourId, codeId, revise }) => {
    const FetchApis = new FetchApi();
    const [dataRecall, setDataRecall] = useState([])
    const [dataNotelist,setDataNotelist] = useState([]);
    const [datadetail, seTdatadetail] = useState("");
    const [modalShow, setModalShow] = React.useState(false);

    useEffect(() => {
        getlistrecall()
        getNoteReivselist();
    }, [])

    function getlistrecall() {

        FetchApis.FethcGet(`/taskflow/getListDetailRecall/${jourId}`).then(res => {
            if (res) {
                setDataRecall(res.data.data);
            }
        })
    }

    function getNoteReivselist() {
        // console.log(codeId)
        FetchApis.FethcGet(`/noterevise/getnotereviseBycode/${codeId}/${revise}`).then(res => {
            if (res) {
                // console.log(res);
                setDataNotelist(res.data.data)
            }
        })
    }

    const handleClickOpen = (datalist) => {
        setModalShow(true);
        seTdatadetail(datalist)
    };
    const handleClose = () => {
        setModalShow(false);
    };


    const columns = [
        {
            name: 'ลำดับ',
            selector: row => row.numbers,
            sortable: true,
            grow: 0.1,
        },
        {
            name: 'ชื่อผู้ส่ง',
            selector: row => row.UserRecall,
            sortable: true,
            grow: 0.5,
        },
        {
            name: 'แผนก',
            selector: row => row.departmentRecall,
            sortable: true,
            grow: 0.2,
        },
        {
            name: 'สถานะ',
            selector: row => <div style={{ color: row.approvecode == '1003' ? 'green' : 'red' }}>
                {row.statusName}
            </div>,
            sortable: true,
            grow: 0.5,
        },
        {
            name: 'ผู้รับเอกสาร',
            selector: row => row.UserTo,
            sortable: true,
            grow: 0.5,
        },
        {
            name: 'แผนก',
            selector: row => row.departmentTo,
            sortable: true,
            grow: 0.2,
        },
        {
            name: 'คำธิบาย',
            selector: row => <div onClick={() => handleClickOpen(row.tasknote)} style={{ width: '100%' }}>
                {row.tasknote != 'undefined' && row.tasknote}
            </div>
            ,
            sortable: true,
            grow: 2,
        },
        {
            name: 'เวลาที่แจ้ง',
            selector: row => <div style={{ color: row.approvecode == '1003' ? 'green' : 'red' }}>
                {row.datetime}
            </div>,
            sortable: true,
            grow: 1,
        },

        // {
        //     name: 'ACTION',
        //     selector: row =>
        //         <div>
        //             {/* <Button variant="outlined" onClick={() => isSelectbatc(row.batchId)}>เลือก</Button> */}
        //             {/* <button onClick={() => onclickCustomer(row.PKDESCRIPTION, row.COLABGROUPID)}>เลือก</button> */}
        //         </div>,
        //     sortable: true,
        //     grow: 0.5,
        // },

    ];

    const customStyles = {

        header: {
            style: {
                minHeight: '56px',
            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                // borderTopColor: defaultThemes.default.divider.default,
            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    // borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        rows: {
            highlightOnHoverStyle: {
                backgroundColor: 'rgb(230, 244, 244)',
                borderBottomColor: '#FFFFFF',
                borderRadius: '25px',
                outline: '1px solid #FFFFFF',
            }
        },

        cells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    // borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
    };

    const conditionalRowStyles = [{

        when: row => row.approvecode == '1003',
        style: {
            backgroundColor: '#EBECF2',
            color: '',
            '&:hover': {
                cursor: 'pointer',
            },
        },

    }]

    return (
        <div style={{ color: 'black' }}>
            {dataNotelist.length>0&&<div>
                {dataNotelist.map((item,index)=>(
                    <div style={{padding:10}}>
                        <label style={{fontSize:18,marginBottom:5}}>คำอธิบาย  </label>
                        {item.typestatus=='4002'?<label style={{fontSize:18,marginBottom:5,marginLeft:10,color:'#3735B5'}}>  Revise</label>:<label style={{fontSize:18,marginBottom:5,marginLeft:10 ,color:'red'}}> ยกเลิก เอกสาร</label>}
                        <div style={{padding:10,margin:5,}}>{item.detaillist}</div>
                        <div>
                            <label style={{}}>วันที่ {item.createdate}</label>
                        </div>
                        <hr/>
                    </div>
                ))}
                </div>}
                {dataRecall.length >0&&<div>
                    <label style={{fontSize:18}}>คำธิบายการแก้ไขข้อมูล</label>
            <DataTable columns={columns}
                data={dataRecall}
                customStyles={customStyles}
                conditionalRowStyles={conditionalRowStyles}
                defaultSortFieldId={1}
                highlightOnHover
                pointerOnHover
                pagination /></div>}



            <Modal
                show={modalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                // centered
            >
                <Modal.Header closeButton style={{backgroundColor:'#C4C4C4'}}>
                    <Modal.Title id="contained-modal-title-vcenter">
                    อธิบายเพิ่มเติม
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  
                    <p>
                      {datadetail}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClose}>เปิด</Button>
                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default ViewRecalldetail